import axios from 'axios'

import { getEnv } from '../../../environment'

import { MAIN_HEADER_REQUEST, ENC_METHODS } from './constants'

import { encryptRequest } from './utils'
import { $authToken } from '../../state/Auth/store'

export enum AXIOS_TYPE {
  JSON = 'JSON',
  FORM_DATA = 'FORM_DATA'
}

/**
 * Настройки для axios
 *
 * Если токен установлен, то условие : token !== '' вернет true
 *
 * @param {string} token
 * @param {string} type 'JSON' | 'FORM_DATA'
 * @returns
 */
export const AxiosInstance = (type = AXIOS_TYPE.JSON) => {
  const environment = getEnv()
  const token = $authToken.getState()

  const apiURL = environment.API_PREFIX
  const versionOnePrefix = environment.API_VERSION_ONE_PREFIX
  const exchangeRecompute = environment.EXCHANGE_RECOMPUTE

  let contentType = 'application/json'
  if (type === AXIOS_TYPE.FORM_DATA) {
    contentType = 'multipart/form-data'
  }

  // Set config defaults when creating the instance
  const instance = axios.create({
    baseURL: `${apiURL}${versionOnePrefix}`,
    headers: {
      ...MAIN_HEADER_REQUEST,
      'Content-Type': contentType,
    },
    withCredentials: token !== '' ? false : true,
    validateStatus: status => {
      return status < 500 // Reject only if the status code is greater than or equal to 500
    },
  })

  if (token) {
    // Alter defaults after instance has been created
    instance.defaults.headers.common.Authorization = `Bearer ${token}`
  }

  instance.interceptors.request.use(
    config => {
      const { method = '', data = {} } = config

      // eslint-disable-next-line no-prototype-builtins
      if ((ENC_METHODS.hasOwnProperty(method)) &&
        exchangeRecompute &&
        config?.headers?.['Content-Type'] !== 'multipart/form-data'
      ) {
        const req = encryptRequest(data)

        const updatedConfig = {
          ...config,
          data: JSON.stringify({ req }),
        }

        return updatedConfig
      }

      return config
    },
    error => {
      return Promise.reject(error)
    },
  )

  return instance
}
